import {Injectable} from '@angular/core';
//import {Http, RequestOptions, Headers, Request, RequestMethod} from '@angular/http';
import {AppConstants} from "../constants/constants";
import {AccessUrl} from "../constants/permission";

@Injectable()
export class PermissionService {
  private token: string;
  private permissionOnPage: string[] = [];
  //private impersonatedPermission: string[] = [];
  //private originalPermission: string[] = [];

  constructor() {
    this.token = localStorage.getItem(AppConstants.localStorage.token);
    const permission = localStorage.getItem(AppConstants.localStorage.permissionOnPage);
    this.permissionOnPage = (permission) ? permission.split(','): [];
  }

  public getUserType() {
    return parseInt(localStorage.getItem(AppConstants.localStorage.userType));
  }

  public hasPermissionOnUrl(url: string) {
    const access = AccessUrl.filter(a => a.url === url);
    if (access.length > 0) {
      return (this.permissionOnPage.indexOf(access[0].permission) >=0);
    }
    return false;
  }

  public getPermissionOnPage() {
    return this.permissionOnPage;
  }

  public setPermissionOnPage(permission) {
    return this.permissionOnPage = permission;
  }

  public hasPermissionOnPage(page: string) {
    return (this.permissionOnPage.indexOf(page) >= 0);
  }

  /**
   * when user turn off data entry then just check url, not param
   * @param url
   */
  public hasPermissionWithoutParam(url: string) {
    const access = AccessUrl.filter(a => {
      if (url.includes(a.url.split('/:')[0])) {
        return a;
      }
      return null;
    });
    if (access) {
      return  (this.permissionOnPage.indexOf(access[0].permission) >= 0);
    }
    return false;
  }
/*   public setImpersonatedPermission(permission) {
    this.impersonatedPermission = permission;
    this.originalPermission = JSON.parse(JSON.stringify(this.permissionOnPage));
    // add new permission to permissionOnPage
    this.impersonatedPermission.forEach(item => {
      if (this.permissionOnPage.findIndex(p => p === item) === -1) {
        this.permissionOnPage.push(item);
      }
    });
    localStorage.setItem(AppConstants.localStorage.permissionOnPage,  JSON.stringify(this.permissionOnPage));
  }*/

  /**
   * function to remove impersonate permission when user turn off data entry
   */
  /*public removeImpersonatedPermission() {
    this.permissionOnPage = JSON.parse(JSON.stringify(this.originalPermission));
    localStorage.setItem(AppConstants.localStorage.permissionOnPage,  JSON.stringify(this.permissionOnPage));
  } */

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/services/permission.service.ts